import { PermissionEnum } from 'app/common/enum'
import { BaseCol } from 'app/components/common/BaseCol'
import { BaseSpace } from 'app/components/common/BaseSpace'
import BaseText from 'app/components/common/BaseText'
import { SectionBase } from 'app/components/common/SectionBase'
import HeaderPage from 'app/components/header/components/HeaderPage'
import { BaseTableManagement } from 'app/components/tables/BaseTableManagement'
import { useVerifyPermission } from 'app/helpers/permission.helper'
import React, { useEffect, useMemo } from 'react'
import { useHook } from './hook'
import { CreateModalLayout, FilterLayout } from './layouts'
import * as S from './styles'

const SchoolManagementContainer: React.FC = () => {
  const {
    columns,
    dataTable,
    handleTableChange,
    isLoading,
    pagination,
    filter,
    onChangeFilter,
    downloadExcel,
  } = useHook()

  const { user, verifyPermissionAndRedirect, verifyPermission } =
    useVerifyPermission()

  useEffect(() => {
    verifyPermissionAndRedirect(PermissionEnum.ReadSchool)
  }, [user])

  const isCreateSchool = useMemo(() => {
    return verifyPermission(PermissionEnum.CreateSchool)
  }, [user])

  return (
    <S.ScrollWrapper>
      <HeaderPage
        titleI18nKey={'Quản lý công đoàn bộ phận'}
        rightComponent={
          isCreateSchool ? (
            <BaseCol>
              <CreateModalLayout />
            </BaseCol>
          ) : null
        }
        isExport={verifyPermission(PermissionEnum.ExportSchool)}
        onPressExport={downloadExcel}
      />

      <SectionBase>
        <BaseSpace size={0}>
          <FilterLayout filter={filter} onChangeFilter={onChangeFilter} />
          <BaseTableManagement
            pagination={{
              ...pagination,
              total: pagination.total,
              showTotal: total => (
                <BaseText children={`Tổng: ${total}`} fontWeight="bold" />
              ),
              showSizeChanger: true,
            }}
            columns={columns}
            dataSource={dataTable}
            onChange={handleTableChange}
            loading={isLoading}
          />
        </BaseSpace>
      </SectionBase>
    </S.ScrollWrapper>
  )
}

export default SchoolManagementContainer
